import { defineStore } from "pinia";
import { routeService } from "@/_services";

export const routeStore = defineStore("route", {
  state: () => ({
    routes: null,
    route: null,
    routesByPlan: null,
    error: null,
    routesExport: null,
    customFilterDate: null,
  }),

  actions: {
    setCustomFilterDate(value){
      this.customFilterDate= value;
    },
    clear() {
      this.routes = null;
      this.route = null;
      this.routesByPlan = null;
      this.error = null;
      this.routesExport = null;
      this.customFilterDate = null;
    },
    getRoutes(pagination, query, sort) {
      this.error = null;
      routeService
        .getRoutes(pagination, query, sort)
        .then((result) => {
          this.routes = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.routesExport = null;
      return routeService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.routesExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getRouteById(routeId) {
      this.error = null;
      this.route = null;
      return routeService
        .getRouteById(routeId)
        .then((result) => {
          this.route = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getRoutesByPlanId(planId) {
      this.error = null;
      this.routesByPlan = null;
      return routeService
        .getRoutesByPlanId(planId)
        .then((result) => {
          this.routesByPlan = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
